// extracted by mini-css-extract-plugin
module.exports = {"pdpSlider":"algoliaProductRecommendationsSection_pdpSlider__cVDDx","pdpTitle":"algoliaProductRecommendationsSection_pdpTitle__qqALU"};